import { Button } from "antd";
import { ArrowLeft } from "lucide-react";

const TopBar = ({ onBack }) => (
  <span className="top-7 left-5 bg-[#141c31]/70 backdrop-blur-md p-4 rounded-full">
    <Button
      type="text"
      className="font-medium !text-white !text-xl mt-1"
      icon={<ArrowLeft className="w-5 h-5 mt-2" />}
      onClick={onBack}
    >
      Back to Upload
    </Button>
  </span>
);

export default TopBar;